<div class="dialog-viewer">
    <h2 mat-dialog-title>Create Price Band</h2>
    <form [formGroup]="form" (ngSubmit)="submit(form)">
        <mat-dialog-content>
            <div class="container-fluid">
                <div class="row">
                    <div class="col">
                        <mat-form-field>
                            <mat-label>Price Band</mat-label>
                            <mat-select required name="priceBandTypeId" id="priceBandTypeId"
                                placeholder="Select Price Band" type="text" formControlName="priceBandTypeId">
                                <mat-option *ngFor="let priceBandType of priceBandTypes"
                                    [value]="priceBandType.id">{{priceBandType.name}} ({{priceBandType.description}})</mat-option>
                            </mat-select>
                            <mat-error *ngIf="form.get('priceBandTypeId').errors?.required">Price Band is required
                            </mat-error>
                            <mat-error *ngIf="form.get('priceBandTypeId').errors?.validationErrors">
                                {{ form.get("priceBandTypeId").errors?.validationErrors}}
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
            </div>
            <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
        </mat-dialog-content>
        <mat-dialog-actions>
            <div class="text-center">
                <button mat-raised-button type="submit" [disabled]="isLoading">Save</button>
                <button mat-raised-button (click)="dialogRef.close('cancel')" color="warn"
                    [disabled]="isLoading">Cancel</button>
            </div>
        </mat-dialog-actions>
    </form>
</div>